var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafepal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5358 0C16.3184 -1.12679e-07 15.1509 0.483616 14.2901 1.34445L0.768217 14.8666C0.256067 15.3787 -4.19303e-06 16.05 0 16.7213C4.19313e-06 17.3925 0.256083 18.0638 0.768232 18.576L9.62953 27.4373V11.7495C9.62953 10.5788 10.5712 9.62969 11.7419 9.62969C16.6881 9.62969 28.7278 9.62969 30.3701 9.62969L39.9996 0.000136472L17.5358 0Z",
    fill: "#4A21EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63002 30.3702H28.2508C29.4215 30.3702 30.3706 29.4211 30.3706 28.2503V12.5625L39.2319 21.4239C39.744 21.9361 40.0001 22.6073 40.0001 23.2786C40.0001 23.9499 39.744 24.6211 39.2319 25.1333L25.71 38.6554C24.8492 39.5162 23.6817 39.9999 22.4643 39.9999L0.000488281 39.9997L9.63002 30.3702Z",
    fill: "#4A21EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafepal);
export default __webpack_public_path__ + "static/media/safepal.8a6f48410184d9e394cea99f57a124ba.svg";
export { ForwardRef as ReactComponent };